"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redactSensitiveInfoFromAppURL = void 0;
/**
 * Redact the pathname and search query from sourcegraph.com URLs to avoid
 * leaking sensitive information from Sourcegraph Cloud, while maintaining
 * non-sensitive query parameters used for attribution tracking.
 *
 * Note that URL redaction also happens in internal/usagestats/event_handlers.go.
 *
 * @param url the original, full URL
 */
function redactSensitiveInfoFromAppURL(url) {
    const sourceURL = new URL(url);
    if (sourceURL.hostname !== 'sourcegraph.com') {
        return url;
    }
    // Redact all GitHub.com code URLs, GitLab.com code URLs, and search URLs to ensure we do not leak sensitive information.
    if (sourceURL.pathname.startsWith('/github.com')) {
        sourceURL.pathname = '/github.com/redacted';
    }
    else if (sourceURL.pathname.startsWith('/gitlab.com')) {
        sourceURL.pathname = '/gitlab.com/redacted';
    }
    else if (sourceURL.pathname.startsWith('/search')) {
        sourceURL.pathname = '/search/redacted';
    }
    else {
        return url;
    }
    const marketingQueryParameters = new Set([
        'utm_source',
        'utm_campaign',
        'utm_medium',
        'utm_term',
        'utm_content',
        'utm_cid',
    ]);
    // Ensure we do not leak search queries or other sensitive info in the URL
    // by only maintaining UTM parameters for attribution.
    for (const [parameter] of sourceURL.searchParams) {
        if (!marketingQueryParameters.has(parameter)) {
            sourceURL.searchParams.set(parameter, 'redacted');
        }
    }
    return sourceURL.href;
}
exports.redactSensitiveInfoFromAppURL = redactSensitiveInfoFromAppURL;
//# sourceMappingURL=util.js.map